'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');
const callbackQueuePromise = require('../../lib/callbackQueuePromise');
const clientConfigPromise = callbackQueuePromise('phxConfigQueue');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * InstagramEmbed
     *
     * This web component will lazy-load wrapped Instagram embeds. Once an
     * embed is scrolled into view, the Instagram embed script will be
     * added to the page, and following that, the embed will be upgraded.
     *
     * @example
     *   <phoenix-instagram-embed src="https://www.instagram.com/..."></phoenix-instagram-embed>`;
     */
    class InstagramEmbed extends pageClass.PhoenixElement {
        connectedCallback() {
            Promise.all([clientConfigPromise, this.canRender()]).then(([config, canRender]) => {
                this.features = config.features;
                if (canRender) {
                    this.observeFirstIntersection();
                }
            });
        }

        onFirstIntersection() {
            if (window.FB && !window.FB.__buffer) {
                window.FB.__buffer = true;
            }
            this._appendInstagramBlockquote()
                .then(this._loadScript)
                .then(() => window.instgrm.Embeds.process());
        }

        _loadScript() {
            return pageClass.util.addScriptResourceOnce('https://www.instagram.com/embed.js');
        }

        _appendInstagramBlockquote() {
            const url = this.getAttr('src', { required: true });
            const token = this.getAttr('token', { required: true });
            const oembed = 'https://graph.facebook.com/v17.0/instagram_oembed?url=';

            let oUrl = `${oembed}${encodeURIComponent(url)}&omitscript=true&access_token=${encodeURIComponent(
                token
            )}`;

            return fetch(oUrl)
                .then((response) => response.json())
                .then((data) => {
                    this.innerHTML = data.html;
                });
        }
    }
    window.customElements.define('phoenix-instagram-embed', InstagramEmbed);
});
